import {
  CreateSyllabusPayload,
  IDeleteSyllabusResponse,
  ISyllabusByIdResponse,
  IUpdateSyllabusPayload,
  IUpdateSyllabusStatusPayload,
  IUpdateSyllabusStatusResponse,
  SyllabusCreateUpdateResponse,
  SyllabusPathParams,
  SyllabusResponse,
} from '../../interface/syllabus.interface';
import api from '../api';

export const getSyllabus = async (params: SyllabusPathParams): Promise<SyllabusResponse> => {
  const response = await api.get<SyllabusResponse>('/syllabus', { params });
  return response.data;
};

export const getSyllabusById = async (id: string): Promise<ISyllabusByIdResponse> => {
  const response = await api.get<ISyllabusByIdResponse>(`/syllabus/${id}`);
  return response.data;
};

export const createSyllabus = async (
  payload: CreateSyllabusPayload,
): Promise<SyllabusCreateUpdateResponse> => {
  const response = await api.post<SyllabusCreateUpdateResponse>('/syllabus', payload);
  return response.data;
};

export const modifySyllabus = async (
  payload: IUpdateSyllabusPayload,
): Promise<SyllabusCreateUpdateResponse> => {
  const response = await api.patch<SyllabusCreateUpdateResponse>(`/syllabus`, payload);
  return response.data;
};

/**
 * Permanently delete a syllabus group by any of its row ids.
 * The backend purges every row sharing the same subjectAssignId, curriculumId
 * and type. Irreversible.
 */
export const deleteSyllabus = async (id: string): Promise<IDeleteSyllabusResponse> => {
  const response = await api.delete<IDeleteSyllabusResponse>(`/syllabus/${id}`);
  return response.data;
};

/**
 * Toggle the active status of a syllabus group by any of its row ids.
 * The backend flips every non-deleted row sharing the same subjectAssignId,
 * curriculumId and type to the target status. Reversible.
 */
export const updateSyllabusStatus = async ({
  id,
  status,
}: IUpdateSyllabusStatusPayload): Promise<IUpdateSyllabusStatusResponse> => {
  const response = await api.patch<IUpdateSyllabusStatusResponse>(`/syllabus/${id}/status`, {
    status,
  });
  return response.data;
};
